import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=e497ec34&scoped=true&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"
import style0 from "tui-color-picker/dist/tui-color-picker.css?vue&type=style&index=0&lang=css&"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&id=e497ec34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e497ec34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e497ec34')) {
      api.createRecord('e497ec34', component.options)
    } else {
      api.reload('e497ec34', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=e497ec34&scoped=true&", function () {
      api.rerender('e497ec34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/ColorPicker.vue"
export default component.exports